import { UseFormRegisterReturn } from "react-hook-form";
import { cn } from "@/utils/classes";

/* Prop Types */
interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  registration: UseFormRegisterReturn;
}

/*
 * TextInput component
 * This component is used to render a text input field inside react-hook-form and works with zod
 */
export const TextInput = ({ label, error, registration, className = "", ...props }: TextInputProps) => {
  return (
    <div className="form-control w-full">
      {label && (
        <label className="label text-sm mb-2">
          <span className="label-text">{label}</span>
        </label>
      )}
      <input type="text" className={cn(`input rounded-md w-full ${error ? "input-error" : ""}`, className)} {...registration} {...props} />
      {error && (
        <label className="label">
          <span className="label-text-alt text-error">{error}</span>
        </label>
      )}
    </div>
  );
};
